<template>
  <div :class="theme == 1 ? 'white' : 'black'">
    <div class="tk-box" v-if="show && list.length > 0">
      <h2 class="tz-style">投资者风险承受能力问卷</h2>
      <div class="test-tm">
        <div
          class="qs_q qs_q1 clearfix"
          v-for="(item, index) in list"
          :key="index"
        >
          <ul class="fl qs_con ml20">
            <li class="qs_title">
              <span>{{ item.id }}</span>
              {{ item.question }}
            </li>
            <li
              class="qs_li"
              v-for="(p, i) in item.questionOptions"
              :key="i"
              :class="item.active == p.optionIndex ? 'qs_li_01' : ''"
              @click="clickITEM(index, item, p.optionIndex, p.id)"
            >
              <input
                type="radio"
                :name="item.id"
                class="radioClass disN"
                :value="p.optionIndex"
              />
              {{ p.optionIndex }}. {{ p.optionText }}
            </li>
            <!-- <li class="qs_li" @click="clickITEM(index, item.id, 'A')" ref="qs1">
              <input
                type="radio"
                :name="item.id"
                class="radioClass disN"
                value="A"
              />
              1. {{ item.aAnswer }}
            </li>
            <li class="qs_li" @click="clickITEM(index, item.id, 'B')" ref="qs2">
              <input
                type="radio"
                :name="item.id"
                class="radioClass disN"
                value="B"
              />
              2. {{ item.bAnswer }}
            </li>
            <li class="qs_li" @click="clickITEM(index, item.id, 'C')" ref="qs3">
              <input
                type="radio"
                :name="item.id"
                class="radioClass disN"
                value="C"
              />
              3. {{ item.cAnswer }}
            </li>
            <li class="qs_li" @click="clickITEM(index, item.id, 'D')" ref="qs4">
              <input
                type="radio"
                :name="item.id"
                class="radioClass disN"
                value="D"
              />
              4. {{ item.dAnswer }}
            </li> -->
          </ul>
        </div>
        <button
          v-if="arr.length == list.length && list.length >= 5"
          class="subt"
          :disabled="disabled"
          @click="subClick()"
        >
          提交
        </button>
        <button v-else-if="list.length >= 5" class="subt1 subt">提交</button>
      </div>
    </div>
    <div class="cp-jg" style v-if="!show && title != ''">
      <!--  <img src="" alt="" class="jg-img">-->
      <div class="resulttitle">风险评测结果</div>
      <div class="jg-h2">{{ title }}</div>
      <div class="fengxian">{{ type }}</div>
      <p class="hl-qd">
        您的获利期待：
        <span>{{ content }}</span>
      </p>
      <p class="check-td">
        您选择资产的态度：
        <span>{{ suggest }}</span>
      </p>
      <div class="mz-sm">
        <p style="margin-top: 20px">测试时间：{{ time }}</p>
        <p>（个人风险承受能力测试有效时长2年）</p>
        <p class="mianze">
          免责声明：
          <br />本公司在此郑重提醒，本公司向您销售的产品或提供的服务将以您的风险承受能力等级和投资品种、期限为基础，若您提供的信息发生任何重大变化，您都应当及时书面通知本公司。本公司建议您审慎评判自身风险承受能力、结合自身投资行为，认真填写您的投资品种、期限，作出审慎的投资判断。
        </p>
      </div>
      <div class="kongbai"></div>
      <div
        class="reset"
        v-if="title != '保守型' && title != '谨慎型'"
        @click="btnClick()"
      >
        确定
      </div>
      <div class="reset" v-else @click="saveImageInfo()">重新测评</div>
    </div>
    <van-overlay :show="show1">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="title">
            <p>尊敬的用户：</p>
            <p>
              为了更准确的评估您的风险承受能力，以匹配更好的服务，请完成风险评测，感谢您的配合！
            </p>
          </div>
          <div class="footer">
            <div class="quxiao" @click="backClick()">取消</div>
            <div class="baocun" @click="saveImageInfo()">立即测评</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { RadioGroup, Radio, Cell, CellGroup, Overlay, Toast } from "vant";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
  getUrlParams,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");

import api from "@/api/mall";
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Overlay);
Vue.use(Toast);
export default {
  data() {
    return {
      radio: "1",
      activeIcon: "https://img.yzcdn.cn/vant/user-active.png",
      inactiveIcon: "https://img.yzcdn.cn/vant/user-inactive.png",
      list: [],
      arr: [],
      show: false,
      show1: true,
      title: "",
      content: "",
      suggest: "",
      type: "",
      routeType: 0,
      theme: 1,
      total: 0,
      time: "",
      disabled: false,
    };
  },
  mounted() {
    var that = this;
    if (userAgent.android) {
      this.$bridge.registermethod("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
  },
  created() {
    if (getUrlParams("routeType")) {
      this.routeType = getUrlParams("routeType");
    }
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
    } else if (this.$route.query.theme == 2) {
      this.theme = 2;
    } else {
      this.theme = 1;
    }
    this.getList();
    // console.log(this.routeType);
    if (this.routeType != 1) {
      this.getCode();
    }
  },
  activated() {
    this.theme = sessionStorage.getItem("theme");
  },
  methods: {
    saveImageInfo() {
      this.show = true;
      this.show1 = false;
    },

    backClick() {
      if (this.routeType == 1) {
        if (userAgent.android) {
          this.$bridge.callmethod("closeContainer");
        } else {
          window.WebViewJavascriptBridge.callHandler(
            "closeContainer",
            function (responseData) {}
          );
        }
      } else {
        this.$router.go(-1);
      }
    },
    btnClick() {
      if (this.routeType == 1) {
        if (userAgent.android) {
          this.$bridge.callmethod("closeContainer");
        } else {
          window.WebViewJavascriptBridge.callHandler(
            "closeContainer",
            function (responseData) {}
          );
        }
      } else {
        this.$router.go(-1);
      }
      // this.$router.back();
    },
    subClick() {
      this.disabled = true;
      function compare(property) {
        return function (a, b) {
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        };
      }
      this.arr.sort(compare("id"));
      var num = [];
      var answers = [];
      // console.log(this.arr);
      for (var i = 1; i <= this.arr.length; i++) {
        num.push(i);
      }
      answers = this.arr.map(function (item) {
        return item.name;
      });
      let params = {
        questionIds: num,
        answers: answers,
      };
      var that = this;
      api.getSave(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          that.show = false;
          that.title = res.data.title;
          that.suggest = res.data.suggest;
          that.time = res.data.time;
          that.content = res.data.content;
          that.type = res.data.type;
          setTimeout(() => {
            that.disabled = false;
          }, 2000);
        } else {
          Toast.fail(res.message);
          setTimeout(() => {
            that.disabled = false;
          }, 2000);
        }
      });
    },
    clickITEM(index, item, s, id) {
      item.active = s;

      Vue.set(this.list, index, item);
      var arr1 = { id: item.id, name: id };
      for (var i = 0; i < this.arr.length; i++) {
        if (this.arr[i].id == item.id) {
          this.arr[i].name = id;
          return;
        }
      }
      this.arr.push(arr1);
      // console.log(this.arr)
    },
    getList() {
      var that = this;
      var params = { page: 1, pageSize: 50 };
      api.getRiskList(params).then(function (res) {
        // console.log(res.data.records);
        if (res.code == 200) {
          that.total = res.data.total;
          that.list = res.data;
        } else if (res.code == 401) {
          setTimeout(() => {
            that.getList();
          }, 1000);
        }
      });
    },
    getCode() {
      var that = this;
      api.getRiskInfo({}).then(function (res) {
        // console.log(res);
        if (res.code == 200) {
          that.show1 = false;
          that.title = res.data.title;
          that.suggest = res.data.suggest;
          that.content = res.data.content;
          that.type = res.data.type;
        } else if (res.code == 401) {
          setTimeout(() => {
            that.getCode();
          }, 1000);
        } else {
          that.show1 = true;
        }
      });
    },
  },
};
</script>
<style  lang="less" scoped>
.white {
  background: #fff;
  color: #333;
  p {
    color: rgba(102, 102, 102, 1);
  }

  .block {
    background-color: #fff;
  }
  .quxiao {
    color: #666;
    border: 1px #ccc solid;
  }
  .title {
    color: rgba(51, 51, 51, 1);
    border-bottom: 0.02rem solid #eeeff4;
  }
  .tz-style {
    color: #333;
  }
  .qs_title {
    color: #333;
    /* 
    //margin-top: 16px; */
  }
  .qs_con {
    border-bottom: 1px solid #eeeff4;
  }
  .qs_li,
  .qs_li_01 {
    color: rgba(102, 102, 102, 1);
  }
  .resulttitle {
    color: rgba(51, 51, 51, 1);
  }
  .hl-qd,
  .check-td {
    color: rgba(102, 102, 102, 1);
    span {
      color: rgba(51, 51, 51, 1);
    }
  }
  .mianze {
    background: rgba(248, 249, 249, 1);
  }
}
.black {
  // color: #f0f1f4;
  background: #12161f;
  min-height: 100vh;

  .block {
    background: #12161f;
  }
  .title {
    color: #f0f1f4;
    border-bottom: 0.02rem solid #242b3b;
  }
  .quxiao {
    color: #f0f1f4;
    background: #242b3b;
    border: 0;
  }
  .tz-style {
    color: #f0f1f4;
  }
  .qs_title {
    color: #f0f1f4;
    /* //margin-top: 16px; */
  }
  .qs_con {
    border-bottom: 1px solid #242b3b;
  }
  .qs_li,
  .qs_li_01 {
    color: #868e9f;
  }
  .cp-jg {
    background: #12161f;
  }
  .resulttitle {
    color: #676d78;
  }
  .hl-qd,
  .check-td {
    color: #f0f1f4;
    span {
      color: #676d78;
    }
  }
  .mianze {
    color: #646b75;
    background: #0b0d11;
  }
}
.tz-style {
  padding: 0.32rem 0 0.1rem 0.32rem;
}
.qs_q1 {
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
  // background: #ffffff;
}
.qs_title_1 {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}
.yuandian {
  width: 4px;
  height: 4px;
  background: rgba(244, 67, 54, 1);
  display: inline-block;
  border-radius: 50%;
  margin-right: 5px;
  vertical-align: 3px;
}
.qs_con {
  // border-bottom: 1px solid #eeeff4;
  padding-bottom: 18px;
  width: 95%;
  /* // margin-top: 16px; */
}
.qs_title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* //margin-top: 16px; */
}
.qs_title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* //margin-top: 16px; */
}
.qs_li {
  min-height: 0.45rem;
  /* //background: url(../static/assets/images/lead/xza1.png) right -3px no-repeat; */
  background: url(../assets/xza1.png) no-repeat;
  background-size: 0.4rem;
  background-position: right center;
  margin-top: 0.32rem;
  font-size: 0.28rem;
  padding-right: 0.8rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: rgba(102, 102, 102, 1);
}
.qs_li_01 {
  min-height: 0.45rem;
  /* //background: url(../static/assets/images/lead/xza2.png) right -3px no-repeat; */
  background: url(../assets/xza2.png) no-repeat;
  background-size: 0.4rem;
  background-position: right center;
  margin-top: 0.32rem;
  font-size: 0.28rem;
  padding-right: 0.8rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: rgba(102, 102, 102, 1);
}
input[type="radio"] {
  display: none;
}
.subt {
  width: 6.86rem;
  height: 0.84rem;
  border: 0;
  background: rgba(244, 67, 54, 1);
  border-radius: 2px;
  color: #ffffff;
  font-size: 0.34rem;
  margin: 0.3rem auto;
  margin-left: 0.32rem;
  text-align: center;
  line-height: 0.84rem;
}
.subt1 {
  background: rgba(244, 67, 54, 0.5);
}
.cp-jg {
  // background: #ffffff;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 32px;
}
.resulttitle {
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  // color: rgba(51, 51, 51, 1);
  text-align: center;
}
.jg-h2 {
  margin-top: 16px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(244, 67, 54, 1);
  text-align: center;
}
.fengxian {
  margin-top: 5px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(244, 67, 54, 1);
  text-align: center;
}
.hl-qd {
  font-size: 15px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  // color: rgba(102, 102, 102, 1);
  margin-top: 32px;
}
.check-td {
  font-size: 15px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  // color: rgba(102, 102, 102, 1);
  margin-top: 16px;
}
.hl-qd span {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: rgba(51, 51, 51, 1);
}
.check-td span {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: rgba(51, 51, 51, 1);
}
.mz-sm {
  margin-top: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 18px;
}
.mianze {
  padding: 13px 8px;

  border-radius: 2px;
  margin-top: 8px;
}
.reset {
  text-align: center;
  height: 0.84rem;

  line-height: 0.84rem;
  background: #f44336;
  color: #ffffff;
  border-radius: 2px;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  width: 6.33rem;

  background: rgba(244, 67, 54, 1);

  position: absolute;
  bottom: 0.5rem;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
}

.block {
  width: 6.3rem;
  height: 4.66rem;
  background-color: #fff;
}
.title {
  width: 5.46rem;
  height: 2.4rem;
  font-size: 0.32rem;
  // color: rgba(51, 51, 51, 1);
  line-height: 0.58rem;
  padding: 0.42rem 0.28rem 0.22rem 0.56rem;
  // border-bottom: 0.02rem solid #eeeff4;
}
.footer {
  height: 55px;
  width: 100%;
  display: flex;
  padding-top: 0.3rem;
  // border-top: 1px solid #ccc;
  justify-content: space-around;
}
.footer div {
  width: 2.4rem;
  height: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
// .quxiao {
//   color: #666;
//   border: 1px #ccc solid;
// }
.baocun {
  border: 1px #f44336 solid;
  background: #f44336;
  color: #fff;
}
</style>